"use client";
import { jsxs as I, jsx as R } from "react/jsx-runtime";
import { c as W, g as Z } from "../../_commonjsHelpers-DaMA6jEr.js";
import j from "clsx";
import { memo as q, useState as tt, useEffect as et } from "react";
import { Box as nt } from "../../blocks/base/Base.js";
import { s as E } from "../../Input.module-DvgZOYt7.js";
var F = { exports: {} };
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function(O, N) {
  (function(x, g) {
    O.exports = g();
  })(W, function() {
    return (
      /******/
      function() {
        var S = {
          /***/
          686: (
            /***/
            function(l, c, t) {
              t.d(c, {
                default: function() {
                  return (
                    /* binding */
                    Q
                  );
                }
              });
              var u = t(279), a = /* @__PURE__ */ t.n(u), f = t(370), y = /* @__PURE__ */ t.n(f), v = t(817), m = /* @__PURE__ */ t.n(v);
              function p(i) {
                try {
                  return document.execCommand(i);
                } catch {
                  return !1;
                }
              }
              var h = function(n) {
                var e = m()(n);
                return p("cut"), e;
              }, d = h;
              function _(i) {
                var n = document.documentElement.getAttribute("dir") === "rtl", e = document.createElement("textarea");
                e.style.fontSize = "12pt", e.style.border = "0", e.style.padding = "0", e.style.margin = "0", e.style.position = "absolute", e.style[n ? "right" : "left"] = "-9999px";
                var r = window.pageYOffset || document.documentElement.scrollTop;
                return e.style.top = "".concat(r, "px"), e.setAttribute("readonly", ""), e.value = i, e;
              }
              var M = function(n, e) {
                var r = _(n);
                e.container.appendChild(r);
                var o = m()(r);
                return p("copy"), r.remove(), o;
              }, H = function(n) {
                var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                }, r = "";
                return typeof n == "string" ? r = M(n, e) : n instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(n == null ? void 0 : n.type) ? r = M(n.value, e) : (r = m()(n), p("copy")), r;
              }, L = H;
              function w(i) {
                "@babel/helpers - typeof";
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? w = function(e) {
                  return typeof e;
                } : w = function(e) {
                  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, w(i);
              }
              var z = function() {
                var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = n.action, r = e === void 0 ? "copy" : e, o = n.container, s = n.target, b = n.text;
                if (r !== "copy" && r !== "cut")
                  throw new Error('Invalid "action" value, use either "copy" or "cut"');
                if (s !== void 0)
                  if (s && w(s) === "object" && s.nodeType === 1) {
                    if (r === "copy" && s.hasAttribute("disabled"))
                      throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    if (r === "cut" && (s.hasAttribute("readonly") || s.hasAttribute("disabled")))
                      throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                  } else
                    throw new Error('Invalid "target" value, use a valid Element');
                if (b)
                  return L(b, {
                    container: o
                  });
                if (s)
                  return r === "cut" ? d(s) : L(s, {
                    container: o
                  });
              }, U = z;
              function T(i) {
                "@babel/helpers - typeof";
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? T = function(e) {
                  return typeof e;
                } : T = function(e) {
                  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, T(i);
              }
              function Y(i, n) {
                if (!(i instanceof n))
                  throw new TypeError("Cannot call a class as a function");
              }
              function D(i, n) {
                for (var e = 0; e < n.length; e++) {
                  var r = n[e];
                  r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(i, r.key, r);
                }
              }
              function B(i, n, e) {
                return n && D(i.prototype, n), e && D(i, e), i;
              }
              function G(i, n) {
                if (typeof n != "function" && n !== null)
                  throw new TypeError("Super expression must either be null or a function");
                i.prototype = Object.create(n && n.prototype, { constructor: { value: i, writable: !0, configurable: !0 } }), n && k(i, n);
              }
              function k(i, n) {
                return k = Object.setPrototypeOf || function(r, o) {
                  return r.__proto__ = o, r;
                }, k(i, n);
              }
              function J(i) {
                var n = $();
                return function() {
                  var r = A(i), o;
                  if (n) {
                    var s = A(this).constructor;
                    o = Reflect.construct(r, arguments, s);
                  } else
                    o = r.apply(this, arguments);
                  return V(this, o);
                };
              }
              function V(i, n) {
                return n && (T(n) === "object" || typeof n == "function") ? n : X(i);
              }
              function X(i) {
                if (i === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return i;
              }
              function $() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;
                try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function A(i) {
                return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                  return e.__proto__ || Object.getPrototypeOf(e);
                }, A(i);
              }
              function P(i, n) {
                var e = "data-clipboard-".concat(i);
                if (n.hasAttribute(e))
                  return n.getAttribute(e);
              }
              var K = /* @__PURE__ */ function(i) {
                G(e, i);
                var n = J(e);
                function e(r, o) {
                  var s;
                  return Y(this, e), s = n.call(this), s.resolveOptions(o), s.listenClick(r), s;
                }
                return B(e, [{
                  key: "resolveOptions",
                  value: function() {
                    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    this.action = typeof o.action == "function" ? o.action : this.defaultAction, this.target = typeof o.target == "function" ? o.target : this.defaultTarget, this.text = typeof o.text == "function" ? o.text : this.defaultText, this.container = T(o.container) === "object" ? o.container : document.body;
                  }
                  /**
                   * Adds a click event listener to the passed trigger.
                   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                   */
                }, {
                  key: "listenClick",
                  value: function(o) {
                    var s = this;
                    this.listener = y()(o, "click", function(b) {
                      return s.onClick(b);
                    });
                  }
                  /**
                   * Defines a new `ClipboardAction` on each click event.
                   * @param {Event} e
                   */
                }, {
                  key: "onClick",
                  value: function(o) {
                    var s = o.delegateTarget || o.currentTarget, b = this.action(s) || "copy", C = U({
                      action: b,
                      container: this.container,
                      target: this.target(s),
                      text: this.text(s)
                    });
                    this.emit(C ? "success" : "error", {
                      action: b,
                      text: C,
                      trigger: s,
                      clearSelection: function() {
                        s && s.focus(), window.getSelection().removeAllRanges();
                      }
                    });
                  }
                  /**
                   * Default `action` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultAction",
                  value: function(o) {
                    return P("action", o);
                  }
                  /**
                   * Default `target` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultTarget",
                  value: function(o) {
                    var s = P("target", o);
                    if (s)
                      return document.querySelector(s);
                  }
                  /**
                   * Allow fire programmatically a copy action
                   * @param {String|HTMLElement} target
                   * @param {Object} options
                   * @returns Text copied.
                   */
                }, {
                  key: "defaultText",
                  /**
                   * Default `text` lookup function.
                   * @param {Element} trigger
                   */
                  value: function(o) {
                    return P("text", o);
                  }
                  /**
                   * Destroy lifecycle.
                   */
                }, {
                  key: "destroy",
                  value: function() {
                    this.listener.destroy();
                  }
                }], [{
                  key: "copy",
                  value: function(o) {
                    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                      container: document.body
                    };
                    return L(o, s);
                  }
                  /**
                   * Allow fire programmatically a cut action
                   * @param {String|HTMLElement} target
                   * @returns Text cutted.
                   */
                }, {
                  key: "cut",
                  value: function(o) {
                    return d(o);
                  }
                  /**
                   * Returns the support of the given action, or all actions if no action is
                   * given.
                   * @param {String} [action]
                   */
                }, {
                  key: "isSupported",
                  value: function() {
                    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"], s = typeof o == "string" ? [o] : o, b = !!document.queryCommandSupported;
                    return s.forEach(function(C) {
                      b = b && !!document.queryCommandSupported(C);
                    }), b;
                  }
                }]), e;
              }(a()), Q = K;
            }
          ),
          /***/
          828: (
            /***/
            function(l) {
              var c = 9;
              if (typeof Element < "u" && !Element.prototype.matches) {
                var t = Element.prototype;
                t.matches = t.matchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector || t.webkitMatchesSelector;
              }
              function u(a, f) {
                for (; a && a.nodeType !== c; ) {
                  if (typeof a.matches == "function" && a.matches(f))
                    return a;
                  a = a.parentNode;
                }
              }
              l.exports = u;
            }
          ),
          /***/
          438: (
            /***/
            function(l, c, t) {
              var u = t(828);
              function a(v, m, p, h, d) {
                var _ = y.apply(this, arguments);
                return v.addEventListener(p, _, d), {
                  destroy: function() {
                    v.removeEventListener(p, _, d);
                  }
                };
              }
              function f(v, m, p, h, d) {
                return typeof v.addEventListener == "function" ? a.apply(null, arguments) : typeof p == "function" ? a.bind(null, document).apply(null, arguments) : (typeof v == "string" && (v = document.querySelectorAll(v)), Array.prototype.map.call(v, function(_) {
                  return a(_, m, p, h, d);
                }));
              }
              function y(v, m, p, h) {
                return function(d) {
                  d.delegateTarget = u(d.target, m), d.delegateTarget && h.call(v, d);
                };
              }
              l.exports = f;
            }
          ),
          /***/
          879: (
            /***/
            function(l, c) {
              c.node = function(t) {
                return t !== void 0 && t instanceof HTMLElement && t.nodeType === 1;
              }, c.nodeList = function(t) {
                var u = Object.prototype.toString.call(t);
                return t !== void 0 && (u === "[object NodeList]" || u === "[object HTMLCollection]") && "length" in t && (t.length === 0 || c.node(t[0]));
              }, c.string = function(t) {
                return typeof t == "string" || t instanceof String;
              }, c.fn = function(t) {
                var u = Object.prototype.toString.call(t);
                return u === "[object Function]";
              };
            }
          ),
          /***/
          370: (
            /***/
            function(l, c, t) {
              var u = t(879), a = t(438);
              function f(p, h, d) {
                if (!p && !h && !d)
                  throw new Error("Missing required arguments");
                if (!u.string(h))
                  throw new TypeError("Second argument must be a String");
                if (!u.fn(d))
                  throw new TypeError("Third argument must be a Function");
                if (u.node(p))
                  return y(p, h, d);
                if (u.nodeList(p))
                  return v(p, h, d);
                if (u.string(p))
                  return m(p, h, d);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
              }
              function y(p, h, d) {
                return p.addEventListener(h, d), {
                  destroy: function() {
                    p.removeEventListener(h, d);
                  }
                };
              }
              function v(p, h, d) {
                return Array.prototype.forEach.call(p, function(_) {
                  _.addEventListener(h, d);
                }), {
                  destroy: function() {
                    Array.prototype.forEach.call(p, function(_) {
                      _.removeEventListener(h, d);
                    });
                  }
                };
              }
              function m(p, h, d) {
                return a(document.body, p, h, d);
              }
              l.exports = f;
            }
          ),
          /***/
          817: (
            /***/
            function(l) {
              function c(t) {
                var u;
                if (t.nodeName === "SELECT")
                  t.focus(), u = t.value;
                else if (t.nodeName === "INPUT" || t.nodeName === "TEXTAREA") {
                  var a = t.hasAttribute("readonly");
                  a || t.setAttribute("readonly", ""), t.select(), t.setSelectionRange(0, t.value.length), a || t.removeAttribute("readonly"), u = t.value;
                } else {
                  t.hasAttribute("contenteditable") && t.focus();
                  var f = window.getSelection(), y = document.createRange();
                  y.selectNodeContents(t), f.removeAllRanges(), f.addRange(y), u = f.toString();
                }
                return u;
              }
              l.exports = c;
            }
          ),
          /***/
          279: (
            /***/
            function(l) {
              function c() {
              }
              c.prototype = {
                on: function(t, u, a) {
                  var f = this.e || (this.e = {});
                  return (f[t] || (f[t] = [])).push({
                    fn: u,
                    ctx: a
                  }), this;
                },
                once: function(t, u, a) {
                  var f = this;
                  function y() {
                    f.off(t, y), u.apply(a, arguments);
                  }
                  return y._ = u, this.on(t, y, a);
                },
                emit: function(t) {
                  var u = [].slice.call(arguments, 1), a = ((this.e || (this.e = {}))[t] || []).slice(), f = 0, y = a.length;
                  for (f; f < y; f++)
                    a[f].fn.apply(a[f].ctx, u);
                  return this;
                },
                off: function(t, u) {
                  var a = this.e || (this.e = {}), f = a[t], y = [];
                  if (f && u)
                    for (var v = 0, m = f.length; v < m; v++)
                      f[v].fn !== u && f[v].fn._ !== u && y.push(f[v]);
                  return y.length ? a[t] = y : delete a[t], this;
                }
              }, l.exports = c, l.exports.TinyEmitter = c;
            }
          )
          /******/
        }, x = {};
        function g(l) {
          if (x[l])
            return x[l].exports;
          var c = x[l] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return S[l](c, c.exports, g), c.exports;
        }
        return function() {
          g.n = function(l) {
            var c = l && l.__esModule ? (
              /******/
              function() {
                return l.default;
              }
            ) : (
              /******/
              function() {
                return l;
              }
            );
            return g.d(c, { a: c }), c;
          };
        }(), function() {
          g.d = function(l, c) {
            for (var t in c)
              g.o(c, t) && !g.o(l, t) && Object.defineProperty(l, t, { enumerable: !0, get: c[t] });
          };
        }(), function() {
          g.o = function(l, c) {
            return Object.prototype.hasOwnProperty.call(l, c);
          };
        }(), g(686);
      }().default
    );
  });
})(F);
var rt = F.exports;
const ot = /* @__PURE__ */ Z(rt), it = q(
  ({
    type: O = "text",
    name: N,
    value: S,
    center: x,
    className: g,
    disabled: l,
    size: c = "normal",
    onCopy: t,
    ...u
  }) => {
    const [a, f] = tt(!1), y = () => {
      f(!0), setTimeout(() => f(!1), 3e3);
    };
    return et(() => {
      new ot("#share-input", {});
    }, []), /* @__PURE__ */ I(nt, { gap: 12, children: [
      N && /* @__PURE__ */ R("span", { className: j(E.name, { [E._center]: x }), children: N }),
      /* @__PURE__ */ I(
        "label",
        {
          id: "share-input",
          "data-clipboard-text": S,
          className: E.label,
          onClick: y,
          children: [
            /* @__PURE__ */ R(
              "input",
              {
                className: j(E.input, E[c], E.datacopy, {
                  [E._disabled]: l,
                  [E._active]: a
                }),
                type: O,
                readOnly: !0,
                value: S,
                ...u
              }
            ),
            /* @__PURE__ */ R(
              "div",
              {
                className: j("material-icons", E.icon),
                "data-icon": a ? "check_circle" : "content_copy"
              }
            )
          ]
        }
      )
    ] });
  }
);
it.displayName = "DataInput";
export {
  it as DataInput
};
